module.exports = __webpack_public_path__ + "img/agence-de-leau.986678a5.jpg";